import { AfterViewInit, Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { StateService } from "../../services/state.service";
import { ArticlesWebSocketsService } from "../../webSockets/articles-web-sockets.service";
import { map, switchMap, take, tap } from 'rxjs/operators';
import { SocketService } from '../../services/socket.service';
import { formatDistance} from 'date-fns'
import { es } from 'date-fns/locale'
import { UserApiService } from '../../api/user-api.service';
import { DOCUMENT } from '@angular/common';
import { interval, pipe, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core'
import Swal from 'sweetalert2';

/* import { JwtHelperService } from '@auth0/angular-jwt';

const helper = new JwtHelperService(); */

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})

export class HeaderComponent implements OnInit, AfterViewInit{ 
    public userName: string;
    public disabled = true
    notificacion:any = []
    page:number= 1
    usuarioBase:any 
    notificar = []
    notifico= []
    activeLang='es'
    user_id:any 
    suscription:Subscription

    constructor(
        public state:StateService,
        public articlesWebSockets:ArticlesWebSocketsService,
        public socketService:SocketService,
        public userApiService:UserApiService,
        @Inject(DOCUMENT) private document:Document,
        private render:Renderer2,
        private translate:TranslateService,
        
    ) { 
        this.translate.setDefaultLang(this.activeLang)
      } 

    ngOnInit() { 
        if(this.state.getValueOf('user').sub  == undefined){
          return 
        } else {

            let data={
                cedula:this.state.getValueOf('user').sub
            }

            this.userApiService.validarPcrc(data).subscribe(data=>{

                if(data!=0){

            this.getNotificaciones() 
            
        }

    })


        }
     
    }
   

     getNotificaciones(){

         try {
            if(this.state.getValueOf('user').sub != null ){
                this.suscription =  this.socketService.getNotificacionesByDocument(this.state.getValueOf('user').sub).subscribe(
                    (res:any) => {
                        this.user_id = res.id 
                            if(this.state.getValueOf('user').sub){
                                this.socketService.getNotificaciones(this.user_id).subscribe(
                                    (noty:any) => { 
                                      
                                      this.notificacion  = noty.filter( n => n.base_id === this.state.getValueOf('selectedPcrc').id_dp_pcrc && n.documento != this.state.getValueOf('user').sub)                                
                                     
                                       
                                      this.notificacion.forEach(({ documento }) => {
                                           if(documento !==this.state.getValueOf('user').sub){
                                            this.notificar     =  this.notificacion.map( n  => n.leidos == 0)
                                            this.notifico      =  this.notificar.filter(n => n == true)
                                           }
                                      });

                                      
                                 
                                     }
                                
                                  );
                              }
                                  
                        
                        
                      }
                 )  
             }
         } catch (error) {
            return  
         }
           
     } 

     ngAfterViewInit(){
         interval(60000).pipe(tap( () => this.getNotificaciones())).subscribe()
    }

    dateFormat(date:Date){
       return  formatDistance(new Date(date), new Date() ,{addSuffix:true, locale:es })
    }

    toggleSideSheet(){
        this.state.toogleSideSheet()
    }

    toggleNotificatons(){
        this.articlesWebSockets.togleNotifications()
    }

   leido(notifica:any){
        this.socketService.getNotificacionesByDocument(this.state.getValueOf('user').sub). pipe(
            map((res:any) => res.id),
            switchMap(id => this.socketService.getNotificacionesLeidas({
                documento:id,
                id_notificacion: notifica.id
            }))).subscribe( ()=> this.getNotificaciones() )
    }

     cambiarIdioma(lang){
          this.activeLang = lang
          this.translate.use(lang) 
    }

    desabilitar(){
      this.render.addClass(this.document.documentElement,'hide')
    }

}
